<template>
  <div :class="$style.customernumber">
    <IconSelect
      :class="$style.icon"
      icon="user"
      height="20"
      width="20"
      :icon-props="{ 'stroke-width': 2 }"
    />

    <span :class="$style.text">{{ username }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'

import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

export default {
  name: 'NavigationCustomerNumber',
  components: {
    IconSelect,
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      username: APP_GETTER.USERNAME,
      // appUserIsSubUser: APP_GETTER.IS_SUBUSER,
      // customerNumber: APP_GETTER.CUSTOMER_NUMBER,
    }),
    // name() {
    //   return this.appUserIsSubUser ? this.username : this.customerNumber
    // },
  },
}
</script>

<style lang="scss" module>
.customernumber {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.25rem;

  font-size: var(--font-xs);
  line-height: 1.25;
}

.icon {
  color: var(--black);
}

.text {
  margin-left: 0.25rem;

  font-size: var(--font-sm);
  line-height: 1;
}
</style>
